import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { CareShell, Panel } from "../../components/care/CareLayout";
import { COMPLIANCE_POLICY_TOOLS } from "./compliancePolicyToolsRegistry";

export default function FacilityAuditToolsPage({ hasFeature }) {
  const [query, setQuery] = useState("");

  const visibleTools = useMemo(() => {
    const q = query.trim().toLowerCase();
    return COMPLIANCE_POLICY_TOOLS.filter((tool) =>
      hasFeature(tool.featureKey),
    ).filter(
      (tool) =>
        !q ||
        tool.label.toLowerCase().includes(q) ||
        tool.description.toLowerCase().includes(q),
    );
  }, [query, hasFeature]);

  return (
    <CareShell className="dashboard-content app-page-content facility-audit-tools-page">
      <section className="care-page-hero">
        <div>
          <span>Washington AFH compliance</span>
          <h1>Facility Audit Tools</h1>
          <p>
            Find the logging tool for any compliance policy — search by name or
            requirement.
          </p>
        </div>
      </section>

      <Panel title="All Audit Tools">
        <label className="compliance-tools-page__search">
          <i className="ti ti-search" />
          <input
            autoFocus
            placeholder="Search audit tools"
            value={query}
            onChange={(event) => setQuery(event.target.value)}
          />
        </label>

        <div className="compliance-tools-page__grid">
          {visibleTools.map((tool) => (
            <Link
              className="compliance-tools-page__item"
              to={tool.path}
              key={tool.code}
            >
              <span className="compliance-tools-page__icon">
                <i className={`ti ${tool.icon}`} />
              </span>
              <span>
                <strong>{tool.label}</strong>
                <small>{tool.description}</small>
              </span>
              <i className="ti ti-chevron-right compliance-tools-page__chevron" />
            </Link>
          ))}
          {!visibleTools.length ? (
            <p className="compliance-tools-page__empty">
              No matching audit tools.
            </p>
          ) : null}
        </div>
      </Panel>
    </CareShell>
  );
}
